import {usePreachingContext} from "../../context/PreachingContext";
import {useCallback, useEffect, useState} from "react";
import classes from "./forms.module.css";
import {createPreaching} from "../../clients/PreachingClient";
import SubmitButton from "../buttons/SubmitButton";
import InputDate from "../fields/InputDate";
import InputFile from "../fields/InputFile";
import sendSuccessAlert, {sendErrorAlert} from "../../services/alertService";
import InputTextArea from "../fields/InputTextArea";

const CreatePreachingForm = () => {

    const [church, setChurch] = useState('');
    const [theme, setTheme] = useState('');
    const [bibleVerse, setBibleVerse] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState(new Date());
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [file, setFile] = useState(null);
    const {isOpenForm, setOpenForm, refresh} = usePreachingContext();
    const [isLoading, setIsLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const close = useCallback(() => {
        setOpenForm(false);
    }, [setOpenForm]);

    useEffect(() => {
        if (!isOpenForm) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                close()
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpenForm, close]);


    if (!isOpenForm) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setUploadProgress(0);
        try {
            await createPreaching(church, theme, bibleVerse, firstname, lastname, description, date, file, (evt) => {
                if (evt.total) {
                    setUploadProgress(Math.round((evt.loaded * 100) / evt.total));
                }
            });
            setOpenForm(false);
            sendSuccessAlert('Проповедь успешно добавлена. Скоро она появится в списке');
            refresh();
        } catch (err) {
            console.error('Ошибка при добавлении проповеди:', err);
            sendErrorAlert('Не удалось добавить проповедь. Проверьте соединение и попробуйте ещё раз.');
        } finally {
            setIsLoading(false);
            setUploadProgress(0);
        }
    }

    function disable() {
        return church.length === 0 ||
            theme.length === 0 ||
            bibleVerse.length === 0 ||
            firstname.length === 0 ||
            lastname.length === 0 ||
            description.length === 0 ||
            file === null
    }

    return (
        <div className={classes.overlay}>
            <div className={classes.modal}>
                {/* ✖ Кнопка-крестик */}
                <button className={classes.closeBtn} onClick={() => {
                    close();
                }} aria-label="Закрыть">
                    ✕
                </button>

                <h4 className={classes.title}>Создание проповеди</h4>

                <form onSubmit={handleSubmit}>
                    <label className={classes.label}>
                        Тема прповеди <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Укажите тему'}
                        type="text"
                        className={classes.input}
                        value={theme}
                        onChange={(e) => setTheme(e.target.value)}
                        required
                    />

                    <InputDate
                        text={`Дата и время проповеди`}
                        placeholder={`Укажите дату и время проповеди`}
                        value={date}
                        onChange={(val) => setDate(val)}
                    />

                    <InputTextArea
                        text={'Тезисы'}
                        value={description}
                        required={true}
                        placeholder={'Опишите основную мысль'}
                        onChange={e => setDescription(e)}
                    />

                    <label className={classes.label}>
                        Библейский стих <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Основной текст'}
                        type="text"
                        className={classes.input}
                        value={bibleVerse}
                        onChange={(e) => setBibleVerse(e.target.value)}
                        required
                    />

                    <label className={classes.label}>
                        Церковь <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Укажите церковь'}
                        type="text"
                        className={classes.input}
                        value={church}
                        onChange={(e) => setChurch(e.target.value)}
                        required
                    />



                    <label className={classes.label}>
                        Имя проповедника <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Введите имя'}
                        type="text"
                        className={classes.input}
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        required
                    />

                    <label className={classes.label}>
                        Фамилия проповедника <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Введите фамилию'}
                        type="text"
                        className={classes.input}
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        required
                    />


                    <InputFile
                        label={"Аудио или видео проповеди"}
                        accept={"video/*,audio/*"}
                        onChange={(e) => setFile(e.target.files[0])}/>

                    {isLoading && uploadProgress > 0 && (
                        <div style={{margin: '8px 0'}}>
                            <div style={{fontSize: '13px', marginBottom: '4px', color: '#555'}}>
                                Загрузка: {uploadProgress}%
                            </div>
                            <div style={{background: '#e0e0e0', borderRadius: '4px', height: '6px'}}>
                                <div style={{
                                    background: '#4caf50',
                                    width: `${uploadProgress}%`,
                                    height: '100%',
                                    borderRadius: '4px',
                                    transition: 'width 0.3s ease'
                                }}/>
                            </div>
                        </div>
                    )}

                    <SubmitButton
                        disabled={disable()}
                        isAnimating={isLoading}
                        text={`✅ Добавить проповедь`}
                    />

                </form>
            </div>
        </div>
    );
}

export default CreatePreachingForm;